import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_pie: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-pie" {...rest}>
      <title>praise-pie</title>
      <ellipse
        transform="rotate(-88.789 75.002 74.998) scale(1.00002)"
        fill="#386CBB"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path
        fill="#FFF"
        d="M76.9 38.8h-1.1c-2.3 0-4.2 1.9-4.2 4.2l.2 22.1c0 2.3 1.9 4.2 4.2 4.2h1.1c2.3 0 4.2-1.9 4.2-4.2L81.1 43c0-2.4-1.9-4.2-4.2-4.2z"
      ></path>
      <path
        fill="#FFE7B8"
        d="M82.6 29.8c0 3.6-2.9 6.6-6.5 6.7-3.6 0-6.6-2.9-6.7-6.5 0-3.6 6.5-15.4 6.5-15.4s6.7 11.6 6.7 15.2z"
      ></path>
      <path
        opacity=".8"
        fill="#F8AE41"
        d="M80.3 32.3c0 2.3-1.8 4.2-4.1 4.2S72 34.7 72 32.4s4.1-9.7 4.1-9.7 4.1 7.2 4.2 9.6z"
      ></path>
      <ellipse fill="#896146" cx="76.5" cy="80.7" rx="37.3" ry="20.5"></ellipse>
      <path fill="#FB7F78" d="M104.8 124.1H48.5l-9.4-42.4h75z"></path>
    </svg>
  );
};
